import { render, staticRenderFns } from "./SetupSiteWizard.vue?vue&type=template&id=76de731c&scoped=true"
import script from "./SetupSiteWizard.vue?vue&type=script&lang=js"
export * from "./SetupSiteWizard.vue?vue&type=script&lang=js"
import style0 from "./SetupSiteWizard.vue?vue&type=style&index=0&id=76de731c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76de731c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76de731c')) {
      api.createRecord('76de731c', component.options)
    } else {
      api.reload('76de731c', component.options)
    }
    module.hot.accept("./SetupSiteWizard.vue?vue&type=template&id=76de731c&scoped=true", function () {
      api.rerender('76de731c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Guide/components/SetupWizard/SetupSiteWizard.vue"
export default component.exports